class CheckinLaterManager  {
  _useCheckinLater = false;
  _isCheckinLater = false;

  setUseCheckinLater(value) {
    this._useCheckinLater = value;
  }

  getUseCheckinLater() {
    if (bookedby.staticData.betaMode) {
      return this._useCheckinLater && bookedby.staticData.betaTest
    }

    return this._useCheckinLater;
  }

  setIsCheckinLater(value) {
    this._isCheckinLater = value;
  }

  getIsCheckinLater() {
    return this._isCheckinLater;
  }
}

const CheckinLaterManagerInstance = new CheckinLaterManager();

module.exports = { checkinLaterState: CheckinLaterManagerInstance };
